module.exports = __webpack_public_path__ + "img/icon-account-payback@3x.00612e25.png";